import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 1.25C15.6086 1.25 19.75 5.39137 19.75 10.5C19.75 15.6086 15.6086 19.75 10.5 19.75C5.39137 19.75 1.25 15.6086 1.25 10.5C1.25 5.39137 5.39137 1.25 10.5 1.25ZM10.5 2.9502C6.33025 2.9502 2.9502 6.33025 2.9502 10.5C2.9502 14.6698 6.33025 18.0498 10.5 18.0498C14.6698 18.0498 18.0498 14.6698 18.0498 10.5C18.0498 6.33025 14.6698 2.9502 10.5 2.9502ZM11.4502 6.00293C12.7618 6.34294 13.7118 7.35658 13.7119 8.5498H12.4189C12.4188 7.82988 11.5336 7.2168 10.4805 7.2168C9.42746 7.21691 8.54214 7.82995 8.54199 8.5498C8.54199 9.28312 9.21427 9.55 10.6357 9.90332C12.0055 10.2566 13.7118 10.6966 13.7119 12.5498C13.7119 13.7431 12.7618 14.7566 11.4502 15.0967V16.5498H9.51172V15.0967C8.20003 14.7567 7.25 13.7431 7.25 12.5498H8.54199C8.54199 13.2697 9.42737 13.8837 10.4805 13.8838C11.5337 13.8838 12.4189 13.2698 12.4189 12.5498C12.4188 11.8167 11.7473 11.5495 10.3262 11.1963C8.95633 10.843 7.25 10.4031 7.25 8.5498C7.2501 7.35655 8.20009 6.34291 9.51172 6.00293V4.5498H11.4502V6.00293Z"
      fill="#222A5C"
    />
  </svg>,
  "DonationHistory"
);
